import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form, FieldArray, getIn } from 'formik';
import { Typography } from '@mui/material';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControlLabel from '@mui/material/FormControlLabel';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Checkbox from '@mui/material/Checkbox';
import CustomSelect from "../CustomComponents/CustomSelect";
import { Link } from "react-router-dom";
import moment from "moment";
import FormHelperText from '@mui/material/FormHelperText';

export default function AddUserDialog({ handleDialogCallback }) {
    const [refresh, setRefresh] = React.useState(true);
    const [open, setOpen] = React.useState(false);    
    const [leadChoices, setLeadChoices] = React.useState([])
    const [appRoleChoices, setAppRoleChoices] = React.useState([])
    const [PropType, setPropType] = React.useState([])
    const [UserItemChoices, setUserItemChoices] = React.useState([]);
    const [costCenterChoices, setCostCenterChoices] = React.useState([]);

    const initialValues = {
        firstName: '',
        lastName: '',
        BYSEmail: '',
        CostCenterID: '',
        lead: '',
        appRole: '',
        password: '',
        confirmPassword: '',
        PayRate:'',
        IsActive: false,
        propList: PropType
    };

    const validFormSchema = Yup.object({
        firstName: Yup.string('Please enter a first name').required('First name is required'),
        lastName: Yup.string('Please enter a last name').required('Last name is required'),
        /*BYSEmail: Yup.string().test(
		'Please enter a BYS Email',
        'Please enter a valid email - xxxxx@us.beyondsoft.com',
        value => (value).match(/^^\w+([\.-]?\w+)*@us.beyondsoft.com$$/)),*/
         BYSEmail: Yup.string()
        .required('BYSEmail is required')
        .test(
            'is-us-beyondsoft-email',
            'Please enter a valid email - xxxxx@us.beyondsoft.com',
            value => /^\w+([\.-]?\w+)*@us\.beyondsoft\.com$/.test(value)
        ),
        CostCenterID: Yup.string('Please enter the Cost Center.').required('Cost Center is required'),
        lead: Yup.string('Please enter a lead/approver for this user'),
        appRole: Yup.string('Please enter a appRole for this user')
        		.required('AppRole is required'),
        PayRate:Yup.string('Please enter a PayRate for this user'),
        password: Yup.string('Please enter a password').min(8, 'Password must be at least 8 characters').required('Password is required').oneOf([Yup.ref('confirmPassword'), null], 'Passwords must match'),
        confirmPassword: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords must match'),
        IsActive: Yup
            .boolean(),
    })

    const onTrigger = React.useCallback((values) => {
        const msg = {
            firstName: values.firstName,
            lastName: values.lastName,
            Email: values.BYSEmail,
            CostCenterID: values.CostCenterID,
            AssignedTo: values.lead,
            AppRoleID: values.appRole,
            PayRate: values.PayRate,
            Password: values.password,
            IsActive: values.IsActive,
            PropList: values.propList
        };

        handleDialogCallback(msg);
        
        handleClose();
    })

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const setLead = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.FirstName + " " + choice.LastName, value: choice.ID}))
        setLeadChoices(choices)
    }

    const setAppRole = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.AppRoleName, value: choice.ID }))
        setAppRoleChoices(choices)
    }

    const setProp = (json) => {
        let choices = [];
        json.forEach(choice => { 
           if (choice.IsActive == true) {
               choices.push({ ID: choice.ID, label: choice.Name, IsDropdown: choice.IsDropdown, value: '', validation: choice.Validation, defaultformat: choice.DefaultFormat })
            }
})
        setPropType(choices)
    }

    const setUserItem = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.Name, value: choice.ID, TypeID: choice.TypeID }))
        setUserItemChoices(choices)
    }

    const setCostCenterItem = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.CommonName, value: choice.ID }))
        setCostCenterChoices(choices)
    }

    React.useEffect(() => {
        if (refresh) {

            fetch('/api/User/dropdown/Assigned', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setLead(json));

            fetch('/api/AppRole/dropdown', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setAppRole(json));

            fetch('/api/UserPropType', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setProp(json));

            fetch('api/user_prop_item', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => { setUserItem(json) });

            fetch('/api/cost_center/dropdown', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => { setCostCenterItem(json) });

            setRefresh(false);
        }
    })

    return (
        <div>
            <Button variant="contained" onClick={handleClickOpen}>
                Add User
            </Button>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
                
                <DialogContent>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        onSubmit={(values, { resetForm }) => {
                            onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (
                            <Form >
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={handleClose}
                                            aria-label="close"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                                            User
                                        </Typography>
                                       <Button autoFocus color="inherit" onClick={props.handleSubmit}>
                                            save
                                        </Button>
                                    </Toolbar>
                                </AppBar>
                                <DialogTitle>Create New BeyondTime User</DialogTitle>
                                   <div>
                                    <FormControl sx={{ m: 1, width: 220 }}>
                                       <TextField
											name="firstName"
											id="outlined-firstName"
											onChange={props.handleChange}
											onBlur={props.handleBlur}
											value={props.values.firstName}
											error={props.touched.firstName && Boolean(props.errors.firstName)}
											helperText={props.touched.firstName && props.errors.firstName}
											label="First Name"
										/>
									</FormControl>

                                    <FormControl sx={{ m: 1, width: 220 }}>
                                        <TextField
                                            required 
                                            name="lastName"
                                            id="outlined-lastName"
											onChange={props.handleChange}
											onBlur={props.handleBlur}
											value={props.values.lastName}
											error={props.touched.lastName && Boolean(props.errors.lastName)}
											helperText={props.touched.lastName && props.errors.lastName}
											label="Last Name"
                                        />
                                        
                                    </FormControl>
                                     <FormControl sx={{ m: 1, width: 260 }}>
                                        <TextField
                                            required
                                            name="BYSEmail"
                                            id="outlined-BYSEmail"                                            
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.BYSEmail}
                                            error={props.touched.BYSEmail && Boolean(props.errors.BYSEmail)}
                                            helperText={props.touched.BYSEmail && props.errors.BYSEmail}
                                            label="BYSEmail"
                                        />                                                                      
                                    </FormControl>
                                </div>
                                 <div>
                                    <FormControl sx={{ m: 1, width: 220}}>
                                        <TextField
                                            type="Password"
                                            name="password"
                                            id="outlined-password"                                         
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.password}
                                            error={props.touched.password && Boolean(props.errors.password)}
                                            helperText={props.touched.password && props.errors.password}
                                            label  ="Password"
                                        />                               
                                    </FormControl>

                                    <FormControl sx={{ m: 1, width: 220}}>
                                    	<TextField
                                            type="Password"
                                            name="confirmPassword"
                                            id="outlined-confirmPassword"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.confirmPassword}
                                            error={props.touched.confirmPassword && Boolean(props.errors.confirmPassword)}
                                            helperText={props.touched.confirmPassword && props.errors.confirmPassword}
                                            label="Confirm Password"
                                        />                             
                                    </FormControl>
								
                                </div>
                                                         
                                <div>

                                    <FormControl  sx={{ m: 1, width: 220}}>
                                        <InputLabel htmlFor="outlined-Name">Lead/Verifier</InputLabel>
                                        <CustomSelect
                                            name="lead"
                                            id="outlined-lead"
                                            options={leadChoices}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.lead}
                                            error={props.touched.lead && Boolean(props.errors.lead)}
                                            helperText={props.touched.lead && props.errors.lead}
                                            label="Lead/Verifier"  
                                            >                                   
                                        </CustomSelect>
                                          {props.touched.lead && Boolean(props.errors.lead) &&
													<FormHelperText error={true}>{props.errors.lead}</FormHelperText>}
                                    </FormControl>
                                    <FormControl  sx={{ m: 1, width: 220 }}>
                                        <InputLabel htmlFor="outlined-App Role">App Role</InputLabel>
                                        <CustomSelect
                                            name="appRole"
                                            id="outlined-AppRole"
                                            options={appRoleChoices}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.appRole}
                                            error={props.touched.appRole && Boolean(props.errors.appRole)}
                                            helperText={props.touched.appRole && props.errors.appRole}
                                            label="App Role" 
                                        >
                                        </CustomSelect>
                                         {props.touched.appRole && Boolean(props.errors.appRole) &&
													<FormHelperText error={true}>{props.errors.appRole}</FormHelperText>}
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl  sx={{ m: 1, width: 220 }}>
                                        <InputLabel  htmlFor="outlined-CostCenterName">Cost Center</InputLabel>
                                        <CustomSelect
                                            name="CostCenterID"
                                            id ="outlined-CostCenterID"
                                            options={costCenterChoices}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.CostCenterID}
                                            error={props.touched.CostCenterID && Boolean(props.errors.CostCenterID)}
                                            helperText={props.touched.CostCenterID && props.errors.CostCenterID}
                                            label= "CostCenterID"
                                         >
                                        </CustomSelect>
                                         {props.touched.CostCenterID && Boolean(props.errors.CostCenterID) &&
													<FormHelperText error={true}>{props.errors.CostCenterID}</FormHelperText>}
                                    </FormControl>
                                     
                                      <FormControl sx={{ m: 1, width: 220 }}>
                                       <TextField
											name="PayRate"
											id="outlined-PayRate"
											onChange={props.handleChange}
											onBlur={props.handleBlur}
											value={props.values.PayRate}
											error={props.touched.PayRate && Boolean(props.errors.PayRate)}
											helperText={props.touched.PayRate && props.errors.PayRate}
											label="Pay Rate"
										/>
									</FormControl>
                                     
                                </div>
                               
                                <FormControl sx={{ m: 1 }}>
                                    <FormControlLabel
                                        name="IsActive"
                                        label="Active"
                                        control={<Checkbox checked={props.values.IsActive} onChange={props.handleChange} />}
                                    />
                                </FormControl>
                                <FieldArray name="propList">
                                        <div>
                                        {props.values.propList.map((p, index) => {
                                            const PropItem = `propList[${index}].value`;
                                            const touchedPropItem = getIn(props.touched, PropItem);
                                            const errorPropItem = getIn(props.errors, PropItem);

                                            if (p.IsDropdown) {
                                                return (
                                                    //<div key={index}>
                                                        <FormControl  sx={{ m:1, width: 235, margin:0}}>
                                                            <InputLabel htmlFor="outlined-p.label" id={p.label + index}  sx={{paddingTop:1.3, paddingLeft:1.3}}>
                                                                {p.label}
                                                            </InputLabel>
                                                            <Select 
                                                                name={PropItem}
                                                                labelId={p.label}
                                                                id={index}
                                                                size="large"
                                                                sx={{ m: 1 }}
                                                                OutlinedInput={index}
                                                                value={p.value}
                                                                label={p.label}
                                                                onChange={props.handleChange}
                                                                
                                                            >
                                                               {UserItemChoices.map((Choice, i) => {
                                                                    if (p.ID == Choice.TypeID) {
                                                                        return (
                                                                            <MenuItem key={i} value={Choice.value}>{Choice.label}</MenuItem>
                                                                        );
                                                                    }
                                                                })}
                                                            </Select>
                                                        </FormControl>
                                                    //</div>
                                                );
                                            } else {
                                                return (
                                                    //<div key={index}>
                                                        
                                                        <FormControl   sx={{ m:1, width: 220}}>
                                                            <TextField
                                                                name={PropItem}
                                                                id={index}
                                                                value={p.value}
                                                                onChange={props.handleChange}
                                                                onBlur={props.handleBlur}
                                                                error={p.value && p.value!=="" && !p.value.match(p.validation)}
                                                                helperText={p.value && p.value!=="" && !p.value.match(p.validation) && "Please select a valid "+p.label + " - "+ p.defaultformat}
                                                                label={p.label}
                                                            />
                                                        </FormControl>
                                                    //</div>
                                                );
                                            }
                                            })}
                                        </div>
                                </FieldArray>
                            </Form>
                        )}
                    </Formik>
                    
                </DialogContent>
                
            </Dialog>
        </div>
    );
}